import { apiClient } from "./client";

export interface LeaveRecord {
  id: string;
  user_id: string;
  org_id: string;
  date: string;
  type: string;
  reason?: string;
}

export async function getMyLeaves(start: string, end: string): Promise<LeaveRecord[]> {
  const res = await apiClient.get("/leave/me", { params: { start, end } });
  return res.data;
}

export async function createLeave(data: { date: string; type: string; reason?: string }): Promise<LeaveRecord> {
  const res = await apiClient.post("/leave", data);
  return res.data;
}
